import fetch from "auth/FetchInterceptor";

const PromotionsService = {};
const promotionsPrefix = "/promotion";

/* ===============================
   GET
================================ */

PromotionsService.getPromotions = async () =>
  await fetch(`${promotionsPrefix}/getAll`, {
    method: "GET",
  });

PromotionsService.getPromotionById = async (id) =>
  await fetch(`${promotionsPrefix}/getById/${id}`, {
    method: "GET",
  });

/* ===============================
   CREATE
================================ */

PromotionsService.createPromotion = async (data) =>
  await fetch(`${promotionsPrefix}/create`, {
    method: "POST",
    data,
    headers: {
      "Content-Type": "multipart/form-data",
    },
  });

/* ===============================
   UPDATE
================================ */

PromotionsService.updatePromotion = async (id, data) =>
  await fetch(`${promotionsPrefix}/update/${id}`, {
    method: "PUT",
    data,
    headers: {
      "Content-Type": "multipart/form-data",
    },
  });

/* ===============================
   DELETE
================================ */

PromotionsService.deletePromotionById = async (id) =>
  await fetch(`${promotionsPrefix}/deleteById/${id}`, {
    method: "DELETE",
  });

export default PromotionsService;
